<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>Settings</h1>
                </div>
                <div class="col-md-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['heading'],
    data(){
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Admin/SettingsPage.vue